import React from 'react';
import { redirectToPortal } from '../utils/portalRedirect';

interface PortalRedirectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinueToHub: () => void;
  token: string;
  userData: any;
}

/**
 * Modal shown to admin-only users who try to log into the Hub portal
 * Offers them a choice to redirect to Admin portal or continue to Hub
 */
const PortalRedirectModal: React.FC<PortalRedirectModalProps> = ({
  isOpen,
  onClose,
  onContinueToHub,
  token,
  userData,
}) => {
  if (!isOpen) return null;

  const handleRedirectToAdmin = () => {
    redirectToPortal('admin', token, userData);
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-gray-600 bg-opacity-75 transition-opacity z-40"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
          <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                  <svg
                    className="h-6 w-6 text-blue-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
                    />
                  </svg>
                </div>
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 className="text-lg font-semibold leading-6 text-gray-900">
                    Did you mean to log into the Admin Portal?
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      You have administrator access. Most admin users use the Admin Portal
                      for managing the 242Network system.
                    </p>
                    <p className="text-sm text-gray-500 mt-2">
                      Would you like to go to the Admin Portal instead, or continue to the Hub Portal?
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 gap-3">
              <button
                type="button"
                onClick={handleRedirectToAdmin}
                className="inline-flex w-full justify-center rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-700 sm:w-auto"
              >
                Go to Admin Portal
              </button>
              <button
                type="button"
                onClick={onContinueToHub}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Continue to Hub
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PortalRedirectModal;

